import script from "./form-gender.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-gender.vue?vue&type=script&setup=true&lang=ts"

import "./form-gender.vue?vue&type=style&index=0&id=0fee6049&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fee6049"]])

export default __exports__